import Vue from 'vue';
import VueRouter from 'vue-router';
import { store } from '@/store';
import { setApiClientAuthorization } from '@/repositories/repository';
import RouterView from './RouterView.vue';

import i18n from './plugins/i18n';

Vue.use(VueRouter);

const AuthCallback = () => import('@/views/authentication/callback/vue');
const AuthError = () => import('@/views/authentication/error/vue');
const Search = () => import('@/views/search/vue');
const Detail = () => import('@/views/detail/vue');
const Simulation = () => import('@/views/simulation/vue');
const SimulationDetails = () => import('@/views/simulation-detail/vue');

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/', // TODO: better use a specific path, this works for now because oidc redirect_uri has been configured for root URL.
      name: 'authentication-callback',
      component: AuthCallback,
      meta: {
        isOidcCallback: true,
      },
    },
    {
      path: '/:userType',
      redirect: '/',
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/:userType/:lang',
      redirect: 'search',
      component: RouterView,
      children: [
        {
          path: 'error', // TODO: better use a specific path related to callback path above
          name: 'authentication-error',
          component: AuthError,
          meta: {
            isPublic: true,
          },
        },
        {
          path: 'search',
          name: 'default',
          component: Search,
        },
        {
          path: 'detail/:slug',
          name: 'detail',
          component: Detail,
        },
        {
          path: 'simulation/:slug',
          name: 'simulation',
          component: Simulation,
        },
        {
          path: 'simulation-detail/:slug',
          name: 'simulation-detail-slug',
          component: SimulationDetails,
        },
        {
          path: 'simulation-detail/:slug/:type',
          name: 'simulation-detail-slug-type',
          component: SimulationDetails,
        },
        {
          path: '*',
          redirect: 'search',
        },
      ],
    },
    // {
    //   name: 'default',
    //   path: '*',
    //   redirect: '/nl/search',
    // },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.params.userType) {
    if (to.params.userType !== 'internal' && to.params.userType !== 'broker') {
      router.push({ name: 'authentication-callback' });
    }
  }
  let language = to.params.lang;
  if (!language) {
    language = 'nl';
  }
  i18n.locale = language;
  const requiresAuth = to.matched.some(record => !record.meta.isPublic);
  if (requiresAuth) {
    const hasAccess = await store.dispatch('auth/oidc/oidcCheckAccess', to);
    if (!hasAccess) {
      return next(new Error(`User does not have access to route ${to.path}`));
    }
    const accessToken = store.getters['auth/oidc/oidcAccessToken'];
    // const idToken = store.getters['auth/oidc/oidcIdToken'];
    setApiClientAuthorization(accessToken);
  }
  return next();
});

export default router;
